import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from '@taxdown/piccolo-web';
import { history } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import { phoneSelector, userAuthSelector } from 'Store/modules/auth/selectors';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import useTranslation from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import TabLinks from 'Components/TabLinks';
import { BASIC_MODAL, CLABE_FORM } from 'Constants/modals';
import { routes } from 'Constants/routes';
import { setBodyOverflow } from 'Styles/utils/utils';
import { SocialProviders } from 'Types/common';
import { SatProps } from '../../types';
import UpdatePassword from '../UpdatePassword';
import UpdatePhone from '../UpdatePhone';
import CustomInput from '../CustomInput';
import * as Styled from './styles';

const ProfileData = ({ setScreen, setSubContent, satValues }: SatProps): JSX.Element => {
  const tax = useSelector(taxSelectedSelector);
  const { isLoading, data, refetch } = useFetchGetUserClabe();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { email, provider } = useSelector(userAuthSelector);
  const phone = useSelector(phoneSelector);

  useEffect(() => {
    setSubContent(true);
  }, []);

  const linkRfc = [
    {
      label: 'common:RFC.profile.title',
      action: () => {
        history.replace(routes.ACCOUNT_RFC);
        setScreen(2);
        setSubContent(false);
      },
    },
  ];

  const linkEfirma = [
    {
      label: 'common:Efirma.profile.title',
      action: () => {
        history.replace(routes.ACCOUNT_EFIRMA);
        setScreen(3);
        setSubContent(false);
      },
    },
  ];
  const linkClable = [
    {
      label: 'common:Clabe.profile.title',
      action: () => {
        setBodyOverflow();
        dispatch(
          showModalAction({
            options: {
              type: CLABE_FORM,
              data: { clabe: data?.CLABE, refetch },
            },
          })
        );
      },
    },
  ];

  const handleOnChangePass = (): void => {
    dispatch(showModalAction({ options: { type: BASIC_MODAL }, Component: UpdatePassword }));
  };
  const handleOnChangePhone = (): void => {
    dispatch(showModalAction({ options: { type: BASIC_MODAL }, Component: UpdatePhone }));
  };

  return (
    <>
      <Text type="fds_heading_bold_H4" color="dark_500" mb="fds_size_24">
        {t('account:Profile.title')}
      </Text>
      <Styled.NotificationGroupTitle type="fds_text_semibold_M" color="dark_500" mb="fds_size_24">
        {t('account:Profile.header.taxdown')}
      </Styled.NotificationGroupTitle>
      <CustomInput label={t('common:InputEmail.label')} value={email} />
      <CustomInput
        label={t('common:InputPass.label')}
        value="********"
        isUpdatable={!SocialProviders[provider.toUpperCase()]}
        onClick={handleOnChangePass}
      />
      <CustomInput
        label={t('common:InputPhone.label')}
        value={phone ?? t('common:InputPhone.placeHolder')}
        isUpdatable
        textAction={!phone ? 'common:InputPhone.button' : 'common:Input.change'}
        onClick={handleOnChangePhone}
      />
      <>
        <Styled.NotificationGroupTitle type="fds_text_semibold_M" color="dark_500" mb="fds_size_24">
          {t('account:Profile.header.sat')}
        </Styled.NotificationGroupTitle>
        <Styled.InputContainer>
          {satValues?.rfcAndPassword ? <TabLinks links={linkRfc} /> : null}
          <TabLinks links={linkEfirma} />
          {!isLoading && tax?.recordId && <TabLinks links={linkClable} />}
        </Styled.InputContainer>
      </>
    </>
  );
};

export default ProfileData;
